module.exports = __webpack_public_path__ + "static/spotify-fbdfe634b48dded569e3c7fe6304bcad.svg";